import { StudentStatus } from "../Account/types";
import { OnboardingAccountExtraInfo } from "../Onboarding/types";

export type StudentVerificationStatus = 'pending' | 'verified' | 'expired';

export type StudentVerificationStatusToText = {
    [key in StudentVerificationStatus]: string;
}

export const StudentVerificationStatusToText: StudentVerificationStatusToText = {
    pending: 'Pending',
    verified: 'Verified',
    expired: 'Expired',
} as const;

export type StudentStatusDto = {
    accountUpdateInfo: OnboardingAccountExtraInfo & {
        studentStatus?: StudentStatus
    }
}